import { EntInitialFilter } from "../../../models/filters/initialFilter";
import { EntEntityTypes } from "../../../models/handBooks/entityTypes";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const entityTypesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

    getEntityTypesList: builder.query<ResponseDataGet<EntEntityTypes>, EntInitialFilter>({
      query: (filter) => ({
        url: `${Paths.handbooks.entitytypes}/get-all`,
        method: "POST",
        body: JSON.stringify(filter)
      }),
    }),
    getEntityTypesById: builder.query<ResponseDataTest<EntEntityTypes>, number>({
      query: (id) => ({
        url: `${Paths.handbooks.entitytypes}/${id}`,
        method: 'GET'
      })
    }),
    addEntityTypes: builder.mutation<ResponseDataTest<EntEntityTypes>, EntEntityTypes>({
      query: (body) => ({
        url: `${Paths.handbooks.entitytypes}`,
        method: "POST",
        body: JSON.stringify(body)
      }),
    }),
    editEntityTypes: builder.mutation<ResponseDataTest<EntEntityTypes>, EntEntityTypes>({
      query: (body,) => ({
        url: `${Paths.handbooks.entitytypes}`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    }),
    deleteEntityTypes: builder.mutation<ResponseDataTest<EntEntityTypes>, number>({
      query: (id) => ({
        url: `${Paths.handbooks.entitytypes}/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetEntityTypesListQuery,
  useAddEntityTypesMutation,
  useEditEntityTypesMutation,
  useDeleteEntityTypesMutation
} = entityTypesApi;
